import { VFlex } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFlex,{staticClass:"not-found",attrs:{"md12":""}},[_vm._v(" "+_vm._s(_vm.text || 'ไม่พบข้อมูล')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }